import { SupportedLanguage } from './posTranslations';

export const onboardingTranslations: Record<SupportedLanguage, Record<string, string>> = {
  ar: {
    title: 'انضمام متجر جديد • Vendor Onboarding',
    subtitle: 'سجل بيانات متجرك وابدأ البيع وإصدار الفواتير فوراً',
    step1: '1. بيانات المتجر',
    step2: '2. الجوال وكلمة المرور',
    step3: '3. التحقق الثنائي (2FA)',

    // Step 1
    step1Header: 'الخطوة 1: هوية المتجر والنشاط التجاري',
    storeNameArabic: 'اسم المتجر بالعربي',
    storeNameArabicPlaceholder: 'مثال: مقهى الأصالة',
    storeNameEnglish: 'Store Name (English)',
    storeNameEnglishPlaceholder: 'e.g. Asala Cafe',
    ownerName: 'اسم المالك أو المسؤول المعتمد',
    ownerNamePlaceholder: 'الاسم الثلاثي',
    businessCategory: 'نوع النشاط التجاري (Store Category)',
    vatNumber: 'الرقم الضريبي (VAT Number)',
    crNumber: 'السجل التجاري (CR Number)',
    btnNextStep1: 'متابعة إلى إعدادات الحساب والجوال',

    // Step 2
    step2Header: 'الخطوة 2: رقم الجوال المعتمد وكلمة المرور',
    phoneLabel: 'رقم الجوال (اسم المستخدم الأساسي للدخول)',
    phoneHelp: 'سيتم إرسال رمز التحقق (2FA) إلى هذا الرقم عند تسجيل الدخول',
    emailLabel: 'البريد الإلكتروني الاحتياطي (اختياري للاسترجاع)',
    passwordLabel: 'كلمة المرور',
    confirmPasswordLabel: 'تأكيد كلمة المرور',
    btnBack: 'السابق',
    btnSendOtp: 'إرسال رمز التحقق 2FA',

    // Step 3
    step3Header: 'تأكيد رقم الجوال (2FA)',
    step3Sub: 'أدخل رمز التحقق المكون من 6 أرقام المرسل إلى:',
    simulatedOtpTitle: 'رمز التطوير الفوري (Simulated SMS OTP):',
    btnActivate: 'تفعيل الحساب وتشغيل الكاشير',
    alreadyHaveAccount: 'لديك حساب متجر بالفعل؟',
    signInHere: 'تسجيل الدخول هنا',

    // Validation
    missingDataTitle: 'بيانات ناقصة',
    missingDataDesc: 'يرجى إدخال اسم المتجر واسم المالك',
    invalidPhoneDesc: 'يرجى إدخال رقم جوال صحيح',
    shortPasswordDesc: 'يجب ألا تقل كلمة المرور عن 6 خانات',
    passwordMismatchDesc: 'كلمتا المرور غير متطابقتين',
    invalidOtpDesc: 'رمز التحقق 2FA غير صالح أو منتهي الصلاحية',
  },

  en: {
    title: 'New Vendor Registration • Store Onboarding',
    subtitle: 'Register your store and start issuing invoices instantly',
    step1: '1. Store Details',
    step2: '2. Mobile & Password',
    step3: '3. 2FA Security',

    // Step 1
    step1Header: 'Step 1: Store Identity & Business Category',
    storeNameArabic: 'Store Name (Arabic)',
    storeNameArabicPlaceholder: 'e.g. Asala Cafe (Arabic)',
    storeNameEnglish: 'Store Name (English)',
    storeNameEnglishPlaceholder: 'e.g. Asala Cafe',
    ownerName: 'Owner or Manager Full Name',
    ownerNamePlaceholder: 'Full Name',
    businessCategory: 'Business Category',
    vatNumber: 'VAT Number (15 digits)',
    crNumber: 'Commercial Registration (CR)',
    btnNextStep1: 'Continue to Account & Mobile Setup',

    // Step 2
    step2Header: 'Step 2: Mobile Number & Password',
    phoneLabel: 'Mobile Number (Primary Login ID)',
    phoneHelp: 'A 2FA verification code will be sent to this number for login',
    emailLabel: 'Recovery Email (Optional)',
    passwordLabel: 'Password',
    confirmPasswordLabel: 'Confirm Password',
    btnBack: 'Back',
    btnSendOtp: 'Send 2FA Verification Code',

    // Step 3
    step3Header: 'Confirm Mobile Number (2FA)',
    step3Sub: 'Enter the 6-digit verification code sent to:',
    simulatedOtpTitle: 'Development Simulated SMS Code:',
    btnActivate: 'Activate Store & Open POS',
    alreadyHaveAccount: 'Already have a vendor account?',
    signInHere: 'Sign in here',

    // Validation
    missingDataTitle: 'Missing Details',
    missingDataDesc: 'Please enter store name and owner name',
    invalidPhoneDesc: 'Please enter a valid mobile number',
    shortPasswordDesc: 'Password must be at least 6 characters',
    passwordMismatchDesc: 'Passwords do not match',
    invalidOtpDesc: 'Invalid or expired 2FA verification code',
  },

  hi: {
    title: 'नया विक्रेता पंजीकरण • स्टोर ऑनबोर्डिंग',
    subtitle: 'अपना स्टोर पंजीकृत करें और तुरंत बिलिंग शुरू करें',
    step1: '1. स्टोर विवरण',
    step2: '2. मोबाइल और पासवर्ड',
    step3: '3. 2FA सुरक्षा',

    step1Header: 'चरण 1: स्टोर पहचान और व्यापार श्रेणी',
    storeNameArabic: 'स्टोर का नाम (अरबी)',
    storeNameArabicPlaceholder: 'उदा. असाला कैफे',
    storeNameEnglish: 'स्टोर का नाम (अंग्रेजी)',
    storeNameEnglishPlaceholder: 'e.g. Asala Cafe',
    ownerName: 'मालिक या प्रबंधक का पूरा नाम',
    ownerNamePlaceholder: 'पूरा नाम दर्ज करें',
    businessCategory: 'व्यापार श्रेणी',
    vatNumber: 'वैट नंबर (VAT Number)',
    crNumber: 'सीआर नंबर (CR Number)',
    btnNextStep1: 'मोबाइल और क्रेडेंशियल्स पर आगे बढ़ें',

    step2Header: 'चरण 2: मोबाइल नंबर और पासवर्ड',
    phoneLabel: 'मोबाइल नंबर (मुख्य लॉगिन आईडी)',
    phoneHelp: 'लॉगिन के लिए इस नंबर पर 2FA सत्यापन कोड भेजा जाएगा',
    emailLabel: 'वैकल्पिक ईमेल (रिकवरी के लिए)',
    passwordLabel: 'पासवर्ड',
    confirmPasswordLabel: 'पासवर्ड की पुष्टि करें',
    btnBack: 'पीछे',
    btnSendOtp: '2FA सत्यापन कोड भेजें',

    step3Header: 'मोबाइल नंबर की पुष्टि करें (2FA)',
    step3Sub: 'इस नंबर पर भेजा गया 6-अंकीय कोड दर्ज करें:',
    simulatedOtpTitle: 'डेवलपमेंट सिमुलेटेड SMS कोड:',
    btnActivate: 'स्टोर सक्रिय करें और POS शुरू करें',
    alreadyHaveAccount: 'क्या पहले से स्टोर खाता है?',
    signInHere: 'यहाँ साइन इन करें',

    missingDataTitle: 'अधूरी जानकारी',
    missingDataDesc: 'कृपया स्टोर और मालिक का नाम दर्ज करें',
    invalidPhoneDesc: 'कृपया एक मान्य मोबाइल नंबर दर्ज करें',
    shortPasswordDesc: 'पासवर्ड कम से कम 6 अक्षरों का होना चाहिए',
    passwordMismatchDesc: 'पासवर्ड मेल नहीं खाते',
    invalidOtpDesc: 'अमान्य या समाप्त हो चुका 2FA कोड',
  },

  ur: {
    title: 'نیا دکاندار رجسٹریشن • اسٹور آن بورڈنگ',
    subtitle: 'اپنا اسٹور رجسٹر کریں اور فوری بلنگ شروع کریں',
    step1: '1. اسٹور کی تفصیلات',
    step2: '2. موبائل اور پاس ورڈ',
    step3: '3. دو طرفہ تصدیق (2FA)',

    step1Header: 'مرحلہ 1: اسٹور کی شناخت اور کاروباری نوعیت',
    storeNameArabic: 'دکان کا نام (عربی)',
    storeNameArabicPlaceholder: 'مثال: مقهى الأصالة',
    storeNameEnglish: 'دکان کا نام (انگریزی)',
    storeNameEnglishPlaceholder: 'e.g. Asala Cafe',
    ownerName: 'مالک یا انچارج کا پورا نام',
    ownerNamePlaceholder: 'پورا نام درج کریں',
    businessCategory: 'کاروباری کیٹگری',
    vatNumber: 'ٹیکس نمبر (VAT Number)',
    crNumber: 'کمرشل رجسٹریشن (CR Number)',
    btnNextStep1: 'موبائل اور پاس ورڈ کی طرف بڑھیں',

    step2Header: 'مرحلہ 2: مجاز موبائل نمبر اور پاس ورڈ',
    phoneLabel: 'موبائل نمبر (بنیادی لاگ ان آئی ڈی)',
    phoneHelp: 'لاگ ان کے وقت اس نمبر پر 2FA تصدیقی کوڈ بھیجا جائے گا',
    emailLabel: 'متبادل ای میل (اختیاری)',
    passwordLabel: 'پاس ورڈ',
    confirmPasswordLabel: 'پاس ورڈ کی تصدیق کریں',
    btnBack: 'واپس',
    btnSendOtp: '2FA کوڈ ارسال کریں',

    step3Header: 'موبائل نمبر کی تصدیق (2FA)',
    step3Sub: 'اس نمبر پر بھیجا گیا 6 ہندسوں کا کوڈ درج کریں:',
    simulatedOtpTitle: 'عارضی ٹیسٹ کوڈ (Simulated SMS):',
    btnActivate: 'اکاؤنٹ فعال کریں اور کیشیر کھولیں',
    alreadyHaveAccount: 'پہلے سے اسٹور اکاؤنٹ موجود ہے؟',
    signInHere: 'یہاں لاگ ان کریں',

    missingDataTitle: 'نامکمل معلومات',
    missingDataDesc: 'براہ کرم اسٹور اور مالک کا نام درج کریں',
    invalidPhoneDesc: 'براہ کرم درست موبائل نمبر درج کریں',
    shortPasswordDesc: 'پاس ورڈ کم از کم 6 حروف پر مشتمل ہونا چاہیے',
    passwordMismatchDesc: 'پاس ورڈ مماثل نہیں ہیں',
    invalidOtpDesc: 'غلط یا زائد المیعاد 2FA کوڈ',
  },

  bn: {
    title: 'নতুন ভেন্ডর রেজিস্ট্রেশন • স্টোর অনবোর্ডিং',
    subtitle: 'আপনার স্টোর নিবন্ধন করুন এবং অবিলম্বে বিলিং শুরু করুন',
    step1: '১. স্টোরের তথ্য',
    step2: '২. মোবাইল ও পাসওয়ার্ড',
    step3: '৩. 2FA সুরক্ষা',

    step1Header: 'ধাপ ১: স্টোরের পরিচয় ও ব্যবসার ধরন',
    storeNameArabic: 'স্টোরের নাম (আরবি)',
    storeNameArabicPlaceholder: 'যেমন: আসলা ক্যাফে',
    storeNameEnglish: 'স্টোরের নাম (ইংরেজি)',
    storeNameEnglishPlaceholder: 'e.g. Asala Cafe',
    ownerName: 'মালিক বা ম্যানেজারের পূর্ণ নাম',
    ownerNamePlaceholder: 'পূর্ণ নাম লিখুন',
    businessCategory: 'ব্যবসার ধরন',
    vatNumber: 'ভ্যাট নম্বর (VAT Number)',
    crNumber: 'সিআর নম্বর (CR Number)',
    btnNextStep1: 'মোবাইল ও পাসওয়ার্ড সেটিংসে যান',

    step2Header: 'ধাপ ২: মোবাইল নম্বর ও পাসওয়ার্ড',
    phoneLabel: 'মোবাইল নম্বর (প্রধান লগইন আইডি)',
    phoneHelp: 'লগইন করার সময় এই নম্বরে একটি 2FA কোড পাঠানো হবে',
    emailLabel: 'রিকভারি ইমেল (ঐচ্ছিক)',
    passwordLabel: 'পাসওয়ার্ড',
    confirmPasswordLabel: 'পাসওয়ার্ড নিশ্চিত করুন',
    btnBack: 'পূর্ববর্তী',
    btnSendOtp: '2FA ভেরিফিকেশন কোড পাঠান',

    step3Header: 'মোবাইল নম্বর নিশ্চিত করুন (2FA)',
    step3Sub: 'এই নম্বরে পাঠানো ৬ সংখ্যার কোডটি লিখুন:',
    simulatedOtpTitle: 'সিমুলেটেড SMS কোড (Testing):',
    btnActivate: 'অ্যাকাউন্ট সক্রিয় করুন এবং ক্যাশিয়ার চালু করুন',
    alreadyHaveAccount: 'ইতিমধ্যে একটি স্টোর অ্যাকাউন্ট আছে?',
    signInHere: 'এখানে সাইন ইন করুন',

    missingDataTitle: 'অসম্পূর্ণ তথ্য',
    missingDataDesc: 'অনুগ্রহ করে স্টোর এবং মালিকের নাম লিখুন',
    invalidPhoneDesc: 'অনুগ্রহ করে একটি সঠিক মোবাইল নম্বর লিখুন',
    shortPasswordDesc: 'পাসওয়ার্ড অন্তত ৬ অক্ষরের হতে হবে',
    passwordMismatchDesc: 'পাসওয়ার্ড দুটি মিলছে না',
    invalidOtpDesc: 'ভুল বা মেয়াদোত্তীর্ণ 2FA কোড',
  },

  ne: {
    title: 'नयाँ विक्रेता दर्ता • पसल अनबोर्डिङ',
    subtitle: 'आफ्नो पसल दर्ता गर्नुहोस् र तुरुन्तै बिलिङ सुरु गर्नुहोस्',
    step1: '१. पसलको विवरण',
    step2: '२. मोबाइल र पासवर्ड',
    step3: '३. 2FA सुरक्षा',

    step1Header: 'चरण १: पसलको पहिचान र व्यापार वर्ग',
    storeNameArabic: 'पसलको नाम (अरबी)',
    storeNameArabicPlaceholder: 'उदा. असाला क्याफे',
    storeNameEnglish: 'पसलको नाम (अंग्रेजी)',
    storeNameEnglishPlaceholder: 'e.g. Asala Cafe',
    ownerName: 'मालिक वा व्यवस्थापकको पूरा नाम',
    ownerNamePlaceholder: 'पूरा नाम लेख्नुहोस्',
    businessCategory: 'व्यापार वर्ग',
    vatNumber: 'भ्याट नम्बर (VAT Number)',
    crNumber: 'सीआर नम्बर (CR Number)',
    btnNextStep1: 'मोबाइल र पासवर्ड सेटअपमा जानुहोस्',

    step2Header: 'चरण २: मोबाइल नम्बर र पासवर्ड',
    phoneLabel: 'मोबाइल नम्बर (मुख्य लगइन आईडी)',
    phoneHelp: 'लगइन गर्दा यस नम्बरमा 2FA प्रमाणीकरण कोड पठाइनेछ',
    emailLabel: 'वैकल्पिक इमेल (पुनर्प्राप्तिको लागि)',
    passwordLabel: 'पासवर्ड',
    confirmPasswordLabel: 'पासवर्ड पुष्टि गर्नुहोस्',
    btnBack: 'पछाडि',
    btnSendOtp: '2FA प्रमाणीकरण कोड पठाउनुहोस्',

    step3Header: 'मोबाइल नम्बर पुष्टि गर्नुहोस् (2FA)',
    step3Sub: 'यस नम्बरमा पठाइएको ६-अंकीय कोड प्रविष्ट गर्नुहोस्:',
    simulatedOtpTitle: 'डेभलपमेन्ट परीक्षण SMS कोड:',
    btnActivate: 'पसल सक्रिय गर्नुहोस् र क्यासियर खोल्नुहोस्',
    alreadyHaveAccount: 'पहिले नै पसल खाता छ?',
    signInHere: 'यहाँ लगइन गर्नुहोस्',

    missingDataTitle: 'अपूर्ण जानकारी',
    missingDataDesc: 'कृपया पसल र मालिकको नाम प्रविष्ट गर्नुहोस्',
    invalidPhoneDesc: 'कृपया मान्य मोबाइल नम्बर प्रविष्ट गर्नुहोस्',
    shortPasswordDesc: 'पासवर्ड कम्तिमा ६ अक्षरको हुनुपर्छ',
    passwordMismatchDesc: 'पासवर्ड मेल खाएन',
    invalidOtpDesc: 'अमान्य वा म्याद सकिएको 2FA कोड',
  },

  tl: {
    title: 'Bagong Pagpaparehistro ng Tindahan • Vendor Onboarding',
    subtitle: 'Irehistro ang iyong tindahan at magsimulang mag-isyu ng resibo agad',
    step1: '1. Impormasyon ng Tindahan',
    step2: '2. Mobile at Password',
    step3: '3. Proteksyong 2FA',

    step1Header: 'Hakbang 1: Pagkakakilanlan ng Tindahan at Kategorya',
    storeNameArabic: 'Pangalan ng Tindahan (Arabic)',
    storeNameArabicPlaceholder: 'Hal. Asala Cafe (Arabic)',
    storeNameEnglish: 'Pangalan ng Tindahan (English)',
    storeNameEnglishPlaceholder: 'Hal. Asala Cafe',
    ownerName: 'Buong Pangalan ng May-ari o Tagapamahala',
    ownerNamePlaceholder: 'Buong Pangalan',
    businessCategory: 'Kategorya ng Negosyo',
    vatNumber: 'Numero ng VAT (15 digits)',
    crNumber: 'Numero ng CR (Commercial Registration)',
    btnNextStep1: 'Magpatuloy sa Mobile at Password',

    step2Header: 'Hakbang 2: Numero ng Mobile at Password',
    phoneLabel: 'Numero ng Mobile (Pangunahing Login ID)',
    phoneHelp: 'Magpapadala ng 2FA verification code sa numerong ito para sa pag-login',
    emailLabel: 'Email para sa Pagbawi (Opsyonal)',
    passwordLabel: 'Password',
    confirmPasswordLabel: 'Kumpirmahin ang Password',
    btnBack: 'Bumalik',
    btnSendOtp: 'Ipadala ang 2FA Code',

    step3Header: 'Kumpirmahin ang Numero ng Mobile (2FA)',
    step3Sub: 'Ipasok ang 6-digit na verification code na ipinadala sa:',
    simulatedOtpTitle: 'Testing SMS OTP Code:',
    btnActivate: 'I-activate ang Tindahan at Buksan ang POS',
    alreadyHaveAccount: 'Mayroon ka na bang account ng tindahan?',
    signInHere: 'Mag-sign in dito',

    missingDataTitle: 'Kulang na Impormasyon',
    missingDataDesc: 'Mangyaring ilagay ang pangalan ng tindahan at may-ari',
    invalidPhoneDesc: 'Mangyaring maglagay ng wastong numero ng mobile',
    shortPasswordDesc: 'Ang password ay dapat may hindi bababa sa 6 na karakter',
    passwordMismatchDesc: 'Hindi magkatugma ang mga password',
    invalidOtpDesc: 'Hindi wasto o nag-expire na ang 2FA code',
  },
};
